import cx from 'classnames';
import React from 'react';
import SlateWsysImage from '|/app/purchase/cart/steps/trade-in/assets/slate-wsys.png';
import LinkButton from '|/components/carvana-ds/link-button';
import { useSlate } from '|/context';
import currency from '|/helpers/currency';
import WsysImage from '|/icons/wsys.png';
import styles from './wsys-promo-card.module.css';

interface WsysPromoCardProps {
  tradeIncentive: number;
  taxSavings: number;
  onClick: () => void;
  analyticsId?: string;
  /** Lets a host drop the card's default bottom margin — see `.container`. */
  className?: string;
  /**
   * `wide` opts into the roomier treatment the trade-in details modal uses:
   * one line of headline, more left padding and a larger image. It only takes
   * effect above the mobile breakpoint, so hosts set it unconditionally — the trade-in step
   * stays stacked at every width by not passing it at all.
   */
  layout?: 'stacked' | 'wide';
}

const WsysPromoCard: React.FC<WsysPromoCardProps> = ({
  tradeIncentive,
  taxSavings,
  onClick,
  analyticsId = 'pp_trade_in_wsys_promo_details',
  className,
  layout = 'stacked'
}) => {
  const { isSlateVehicle } = useSlate();
  const savingsAmount = currency(tradeIncentive + taxSavings, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  return (
    <div className={cx(styles.container, layout === 'wide' && styles.containerWide, className)}>
      <div className={styles.content}>
        <div className={styles.title}>
          Trade in to <br className={styles.titleBreak} />
          save {savingsAmount}
        </div>
        <LinkButton
          className={styles.link}
          underline={false}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            onClick();
          }}
          data-analytics-id={analyticsId}
        >
          See details
        </LinkButton>
      </div>
      <div className={styles.imageContainer}>
        <svg
          className={styles.curvedBackground}
          xmlns="http://www.w3.org/2000/svg"
          width="192"
          height="106"
          viewBox="0 0 192 106"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            d="M191.4 106H134.582C76.7261 80.0221 29.9979 42.4118 0 0H191.4V106Z"
            fill={isSlateVehicle ? 'var(--reference-silver-200)' : 'var(--reference-blue-600)'}
          />
        </svg>
        <img
          src={isSlateVehicle ? SlateWsysImage : WsysImage}
          alt="Trade in your vehicle"
          className={styles.carsImage}
        />
      </div>
    </div>
  );
};

export default WsysPromoCard;
